import pimg from "../images/projects/img-1.png";
import pimg2 from "../images/projects/img-2.jpg";
import pimg3 from "../images/projects/img-3.jpg";
import pimg4 from "../images/projects/img-4.jpg";
import pimg5 from "../images/projects/img-5.jpg";

import sSingleimg1 from "../images/project-single/2.jpg";
import sSingleimg2 from "../images/project-single/3.jpg";

const Projects = [
  {
    Id: "1",
    pImg: pimg,
    subTitle: "Auckland, New Zealand",
    title: "BBQ Cleaning ",
    description: "BBQ CLEAN - BBQ Cleaning",
    spImg1: sSingleimg1,
    spImg2: sSingleimg2,
  },
  {
    Id: "2",
    pImg: pimg2,
    subTitle: "Auckland, New Zealand",
    title: "Express Cleaning $149 Special",
    description: "CLEAN$149 - Express Cleaning $149 Special",
    spImg1: sSingleimg1,
    spImg2: sSingleimg2,
  },
  {
    Id: "3",
    pImg: pimg3,
    subTitle: "Auckland, New Zealand",
    title: "Home Cleaning - End of Lease",
    description: "VACATE - Home Cleaning - End of Lease ",
    spImg2: sSingleimg2,
  },
  {
    Id: "4",
    pImg: pimg4,
    subTitle: "Auckland, New Zealand",
    title: "Home Cleaning - Once off",
    description: "CLEAN ONCE - Home Cleaning - Once off",
    spImg1: sSingleimg1,
    spImg2: sSingleimg2,
  },
  {
    Id: "5",
    pImg: pimg5,
    subTitle: "Auckland, New Zealand",
    title: "Home Cleaning - Regular",
    description: "CLEAN REG - Home Cleaning - Regular",
    spImg1: sSingleimg1,
    spImg2: sSingleimg2,
  },
  {
    Id: "6",
    pImg: pimg5,
    subTitle: "Auckland, New Zealand",
    title: "Office Cleaning - Once off ",
    description: "COMM ONCE - Office Cleaning - Once off",
    spImg1: sSingleimg1,
    spImg2: sSingleimg2,
  },
  {
    Id: "6",
    pImg: pimg5,
    subTitle: "Auckland, New Zealand",
    title: "Office Cleaning - Regular ",
    description: "COMM REG - Office Cleaning - Regular ",
    spImg1: sSingleimg1,
    spImg2: sSingleimg2,
  },
  {
    Id: "6",
    pImg: pimg5,
    subTitle: "Auckland, New Zealand",
    title: "Oven Cleaning  ",
    description: "OVEN CL - Oven Cleaning",
    spImg1: sSingleimg1,
    spImg2: sSingleimg2,
  },
];
export default Projects;
